import * as React from 'react'
import * as Styles from './HomeItemTag.style'

interface HomeItemTagProp {
    text: string
}

function HomeItemTag(props: HomeItemTagProp) {

    const renderTypeImage = (type: string): string => {
        switch (type) {
            case 'PPT':
            return 'https://static-1253442168.image.myqcloud.com/picture/10490565_8a0dab7c2e8ae72071db4d7b6f65d047.jpg'
            case '视频':
            return 'https://static-1253442168.image.myqcloud.com/picture/10490565_344906f9b84242bc8d061c7874601dbf.jpg'
            case '音频':
            return 'https://static-1253442168.image.myqcloud.com/picture/10490565_bec5cf6711408e987f8a08b35f00d844.jpg'
        }
    }

    return (
        <div className={Styles.WkNewTag}>
            <img src={renderTypeImage(props.text)} alt=""/>
        </div>
    )
}

export default HomeItemTag



// WEBPACK FOOTER //
// ./src/views/Home/components/HomeFavourableRoll/HomeItemTag.tsx